import { FulfillmentMethod } from 'models/fulfillmentMethods';
import { SelectOption } from 'components/select/types';
import { IntlShape, useIntl } from 'react-intl';
import { useMemo } from 'react';
import { BaseSelect } from 'components/BaseSelect';
import { useAppStore } from 'hooks/state/useAppStore';
import { useTransitiveCacheStore } from 'hooks/state/useTransitiveCacheStore';

interface FulfillmentMethodSelectProps {
  selectedFulfillmentMethods?: string[];
  setSelectedFulfillmentMethods?: (value: string[]) => void;
  className?: string;
  showConfirmationButton?: boolean;
}

const mapMethodToFulfillmentMethodOption = (
  fulfillmentMethod: FulfillmentMethod,
  intl: IntlShape
): SelectOption<string> => ({
  value: fulfillmentMethod.fulfillmentMethod,
  label: intl.formatMessage({
    id: `fulfillment.method.${fulfillmentMethod.fulfillmentMethod}`,
    defaultMessage: fulfillmentMethod.fulfillmentMethod,
  }),
});

export function FulfillmentMethodSelect({
  selectedFulfillmentMethods = undefined,
  setSelectedFulfillmentMethods = undefined,
  className = undefined,
  showConfirmationButton = false,
}: FulfillmentMethodSelectProps) {
  const intl = useIntl();

  const { allFulfillmentMethods } = useTransitiveCacheStore();
  const allFulfillmentMethodOptions = useMemo(
    () => allFulfillmentMethods.map(fm => mapMethodToFulfillmentMethodOption(fm, intl)),
    [allFulfillmentMethods, intl]
  );

  const { fulfillmentMethods, setFulfillmentMethods } = useAppStore();

  return (
    <BaseSelect
      id="fulfillment-method-filter"
      className={className}
      selectedItems={selectedFulfillmentMethods ?? fulfillmentMethods ?? []}
      setSelectedItems={setSelectedFulfillmentMethods ?? setFulfillmentMethods}
      allOptionItems={allFulfillmentMethodOptions}
      label={intl.formatMessage({ id: 'filter.key.selectedFulfillmentMethods', defaultMessage: 'Fulfillment' })}
      showConfirmButton={showConfirmationButton}
    />
  );
}
